interface ErrorMessageProps {
  message: string;
}

export const ErrorMessage = ({ message }: ErrorMessageProps) => {
  return (
    <div className="w-full max-w-2xl mx-auto p-6">
      <div className="bg-destructive/10 border border-destructive/20 rounded-lg p-8 text-center">
        <svg className="w-16 h-16 text-destructive mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <h2 className="text-2xl font-bold text-foreground mb-2">Something Went Wrong</h2>
        <p className="text-muted-foreground">{message}</p>
      </div>
    </div>
  );
};
